export default __webpack_public_path__ + "static/exp1-a17bb15c90c95dc2ff227176f5ae59fa.png";